"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _badge = require("@design/ui/badge");
var _utils = require("@design/lib/utils");
var _DeviationScoreBar = require("@common/components/review/DeviationScoreBar");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ImportanceBadge(_ref) {
  var importance = _ref.importance;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_badge.Badge, {
    "data-sentry-element": "Badge",
    "data-sentry-component": "ImportanceBadge",
    "data-sentry-source-file": "ImportanceBadge.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      "aria-hidden": "true",
      className: (0, _utils.cn)("size-2 rounded-full", _DeviationScoreBar.SEGMENT_BAR_CLASS[importance])
    }), importance]
  });
}
var _default = exports.default = ImportanceBadge;